module.exports = __webpack_public_path__ + "static/media/logo.4d8e91e3.svg";